/**
 * Fluidité B4 (P5#22) — Carte « Dossiers repris de … » du tableau de bord.
 *
 * Après « Départ d'un collaborateur », le remplaçant voit ce qu'il reprend (chantiers,
 * actions, réunions, CR en brouillon, lots confiés) avec des liens, jusqu'à ce qu'il
 * clique « C'est noté ». GET /api/me/dossiers-repris ; rien n'est affiché sinon.
 */
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { ArrowsLeftRight, X } from '@phosphor-icons/react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function DossiersReprisCard() {
  const [cartes, setCartes] = useState([]);

  useEffect(() => {
    axios.get(`${API_URL}/api/me/dossiers-repris`, { withCredentials: true })
      .then((r) => setCartes(Array.isArray(r.data) ? r.data : []))
      .catch(() => setCartes([]));
  }, []);

  if (!cartes.length) return null;

  const vu = async (id) => {
    try {
      await axios.post(`${API_URL}/api/me/dossiers-repris/${id}/vu`, {}, { withCredentials: true });
    } catch { /* la carte disparaît quand même */ }
    setCartes((c) => c.filter((x) => x.id !== id));
  };

  return (
    <div className="space-y-3 mb-6">
      {cartes.map((c) => (
        <div key={c.id} className="border border-[#1E3A5F] bg-[#F4F7FB] p-4" data-testid="dossiers-repris">
          <div className="flex items-start gap-3">
            <ArrowsLeftRight size={22} className="text-[#1E3A5F] shrink-0 mt-0.5" />
            <div className="flex-1 min-w-0">
              <p className="font-medium text-[#1E3A5F]">Dossiers repris de {c.partant_nom}</p>
              <p className="text-sm text-[#2C2C2C]">{c.resume}</p>
              {c.chantiers?.length > 0 && (
                <p className="text-sm mt-2 flex flex-wrap gap-x-3 gap-y-1">
                  {c.chantiers.map((ch) => (
                    <Link key={ch.id} to={`/chantiers/${ch.id}`} className="underline text-[#1E3A5F]">
                      {ch.name || 'Chantier'}{ch.responsable ? ' (responsable)' : ''}
                    </Link>
                  ))}
                </p>
              )}
              {c.actions?.length > 0 && (
                <ul className="text-xs text-[#4A4A4A] mt-2 space-y-0.5">
                  {c.actions.slice(0, 5).map((a) => (
                    <li key={a.id}>
                      <Link to={`/chantiers/${a.chantier_id}?tab=taches`} className="hover:underline">
                        {a.titre || 'Action'}{a.chantier_name ? ` — ${a.chantier_name}` : ''}
                      </Link>
                    </li>
                  ))}
                  {c.actions.length > 5 && <li><Link to="/mes-taches" className="underline">et {c.actions.length - 5} autre(s) dans Ma semaine</Link></li>}
                </ul>
              )}
            </div>
            <button type="button" onClick={() => vu(c.id)} className="text-xs text-[#1E3A5F] underline shrink-0 inline-flex items-center gap-1" data-testid="dossiers-repris-vu">
              <X size={12} /> C'est noté
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}
